<template>
  <div class="checkbox-wrapper">
    <div class="checkbox" v-on:click="toggle">
      <img :src="require('@/assets/icons/v-blue.svg')" class="checkmark" v-if="checked">
    </div>
    <div class="text">
      {{text}}
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckBox',
  props: {
    text: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
    },
    toggle: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/base-ui/src/scss/riseup-colors';

.checkbox-wrapper {
  display: flex;
  margin-bottom: 20px;
  width: 100%;

  .checkbox {
    height: 25px;
    width: 25px;
    border-radius: 4px;
    border: solid 1px #979797;
    cursor: pointer;
    .checkmark {
      height: 100%;
      width: 100%;
    }
  }
  .text {
    padding-top: 5px;
    font-size: 14px;
    margin-right: 20px;
  }
}
</style>
